import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import RideRequestDetailsContent from "./RideRequestDetailsContent";

function DetailsRequestsCity() {
  const { uuid } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const item = location.state?.item;
  const itemMatchesRoute = item && String(item.uuid) === String(uuid);
  const returnTo = location.state?.returnTo || "/Request_city";
  const detailsPath = `/DetailsRequestsCity/${uuid}`;

  const goBackToList = () => {
    if (location.state?.returnTo) {
      navigate(returnTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="dev-table">
          <Navbar />
          <div className="table-card">
            <div className="details passenger-details">
              <div className="mb-3">
                <a
                  className="edit"
                  href={returnTo}
                  onClick={(e) => {
                    e.preventDefault();
                    goBackToList();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa fa-arrow-left me-1"></i>
                  Back
                </a>
              </div>
              {itemMatchesRoute ? (
                <RideRequestDetailsContent
                  item={item}
                  type="city_ride"
                  detailsPath={detailsPath}
                  listReturnTo={returnTo}
                />
              ) : (
                <p className="passenger-details-empty">
                  Ride details are available from the city requests list.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DetailsRequestsCity;
